import Myapp from "./Components/Myapp"

function App() {
  return (
    <div>
      <Myapp />
    </div>
  )
}

export default App